<div class="row">
    <div class="col-md-12">

        <div class="col-sm-3 text-right table-actions-buttons" style="position: fixed;top: 85px;right: 0px;">
            <a class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                <i class="fas fa-plus text-white-50"> <span class="button-text">Create</span></i>
            </a>
        </div>

        <div class="row container-fluid" style="margin-bottom: 5px;">
            <div class="col-md-1 text-right">
                <label>Entity: </label>
            </div>
            <div class="col-md-11">
                <select>
                    <option selected="selected" class="option">Assessments</option>
                    <option class="option">Coaches</option>
                    <option class="option">Clients</option>
                </select>
            </div>
        </div>
        <div class="row container-fluid" style="margin-bottom:30px;">
            <div class="col-md-1 text-right">
                <label>Reports:</label>
            </div>
            <div class="col-md-11 grid">
                <select>
                    <option selected="selected" class="option">All</option>
                    <option class="option">Taken by month</option>
                    <option class="option">Type</option>
                    <option class="option">Average results</option>
                </select>
                <span>Click on the desired report so see details</span>
            </div>
        </div>

        <div class="row">
            <div class="col-xm-12 col-sm-6">
                <div class="graphics images card shadow">
                    <div style="display: block;">
                        <canvas baseChart
                                [datasets]="assessmentsByMonthDatasets"
                                [labels]="assessmentsByMonthLabel"
                                [options]="assessmentsByMonthOptions"
                                [legend]="assessmentsByMonthLegend"
                                [chartType]="assessmentsByMonthChartType"
                                [colors]="colors"></canvas>
                    </div>
                </div>
            </div>
            <div class="col-xm-12 col-sm-6">
                <div class="graphics images card shadow">
                    <div style="display: block">
                        <canvas baseChart
                                [datasets]="assessmentsBySetDatasets"
                                [labels]="assessmentsBySetLabel"
                                [options]="assessmentsBySetOptions"
                                [legend]="assessmentsBySetLegend"
                                [chartType]="assessmentsBySetChartType"
                                [colors]="colors"></canvas>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xm-12 col-sm-6">
                <div class="images graphics card shadow">
                    <div style="display: block">
                        <canvas baseChart
                                [datasets]="averageResultDatasets"
                                [labels]="averageResultLabel"
                                [options]="averageResultOptions"
                                [legend]="averageResultLegend"
                                [chartType]="averageResultChartType"
                                [colors]="colors"></canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
